<template>
    <div ref="girl" class="hero">
      <div  class="girl"></div>

    </div>
</template>

<script>
import { TimelineLite } from 'gsap'
export default {
name: "MoleculeHeroAvatar",
  mounted() {
    const { girl } = this.$refs
    const { message } = this.$refs
    const timeline = new TimelineLite()
    timeline
        .to(girl, 1, { x: 250, y:100, rotation: 0 })
        // .to(message, 1, { x: 150, y:100, rotation: 0 }) //
  }
}
</script>

<style scoped>

</style>
